import AppIconButton, { AppIconButtonProps } from "../Button/AppIconButton";
import AppIcon from "../Icons/AppIcon";

interface Props extends Omit<AppIconButtonProps, "children"> {}

export function AppModalCloseIconButton({ ...otherProps }: Props) {
  return (
    <AppIconButton edge='end' title='Close' {...otherProps}>
      <AppIcon of='close' />
    </AppIconButton>
  );
}
